import React, { FC } from "react";
import {
  CardIconWrapper,
  CardIconWrapperProps,
} from "../CardIconWrapper/CardIconWrapper";

import { Icon } from "@UI/Components/Icon/Icon";

import { AmericanExpressIcon } from "../../../Icons/AmericanExpress/AmericanExpress";

type Props = Omit<CardIconWrapperProps, "children">;

export const AmericanExpressCardIcon: FC<Props> = (props) => {
  return (
    <CardIconWrapper {...props}>
      <Icon as={AmericanExpressIcon} />
    </CardIconWrapper>
  );
};
